export interface SubskrypcjeFiltrModel {
    subskrypcjaOd: string;
    subskrypcjaDo: string;
    dataOstatniegoZdarzeniaOd: string;
    dataOstatniegoZdarzeniaDo: string;
    noweZdarzenia: string;
    systemId: string;
    status: string[],
}

export class SubskrypcjeFiltr {
    static readonly filtrKey = 'sub-filtr';
}